import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import animate from '@/assets/css/animate.css'
import '@/assets/css/css.css'

import axios from 'axios'
import {post,get} from '@/api/api'
import querystring from 'querystring'
import "babel-polyfill"
window._ = require('lodash');

Vue.prototype.bus = new Vue();
Vue.prototype.$qs = querystring;
Vue.prototype.$post = post;
Vue.prototype.$get = get;

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
Vue.config.productionTip = false //阻止 vue 在启动时生成生产提示

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js